import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionItemCustomView: ITrialInstitutionItemCustomViewLoadActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD,
            trialId
        }
    },
    LoadTrialInstitutionItemCustomViewById: ITrialInstitutionItemCustomViewLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_BY_ID,
            id
        }
    },
    LoadTrialInstitutionItemCustomViewDataEntryById: ITrialInstitutionItemCustomViewLoadDataEntryByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_DATAENTRY_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialInstitutionItemCustomViewLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionItemCustomViewLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitutionItemCustomView: ITrialInstitutionItemCustomViewSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE,
            formData
        }
    },

    SaveTrialInstitutionItemCustomViewDataEntry: ITrialInstitutionItemCustomViewSaveDataEntryActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_DATAENTRY,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionItemCustomViewSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionItemCustomViewSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitutionItemCustomView: ITrialInstitutionItemCustomViewCreateActionCreator = (trialId, institutionId, formTemplateId) => {

        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE,
            trialId,
            institutionId,
            formTemplateId
        }
    },
    CreateSuccess: ITrialInstitutionItemCustomViewCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionItemCustomViewCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionItemCustomViewClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionItemCustomViewFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_FILTER,
            formFilter
        }
    };


export const
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_BY_ID = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_BY_ID",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_DATAENTRY_BY_ID = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_DATAENTRY_BY_ID",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_SUCCESS = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_FAILURE = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_FAILURE",

    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_DATAENTRY = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_DATAENTRY",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_SUCCESS = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_FAILURE = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_FAILURE",

    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_SUCCESS = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_FAILURE = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_FAILURE",


    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CLEAR = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CLEAR",

    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_FILTER = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_FILTER";

export interface ITrialInstitutionItemCustomViewLoadAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD";
    trialId: number;
}

export interface ITrialInstitutionItemCustomViewLoadActionCreator {
    (trialId: number): ITrialInstitutionItemCustomViewLoadAction;
}

export interface ITrialInstitutionItemCustomViewLoadByIdAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionItemCustomViewLoadByIdActionCreator {
    (id: number): ITrialInstitutionItemCustomViewLoadByIdAction;
}

export interface ITrialInstitutionItemCustomViewLoadDataEntryByIdAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_DATAENTRY_BY_ID";
    id: number;
}

export interface ITrialInstitutionItemCustomViewLoadDataEntryByIdActionCreator {
    (id: number): ITrialInstitutionItemCustomViewLoadDataEntryByIdAction;
}

export interface ITrialInstitutionItemCustomViewLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_SUCCESS";
    formData: Dtos.TrialInstitutionItemCustomView | Dtos.TrialInstitutionItemCustomView[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemCustomViewLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionItemCustomView | Dtos.TrialInstitutionItemCustomView[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionItemCustomViewLoadSuccessAction;
}

export interface ITrialInstitutionItemCustomViewLoadFailureAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemCustomViewLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemCustomViewLoadFailureAction;
}

export interface ITrialInstitutionItemCustomViewSaveAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE";
    formData: Dtos.TrialInstitutionItemCustomView;

}

export interface ITrialInstitutionItemCustomViewSaveActionCreator {
    (
        formData: Dtos.TrialInstitutionItemCustomView
    ): ITrialInstitutionItemCustomViewSaveAction;
}

export interface ITrialInstitutionItemCustomViewSaveDataEntryAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_DATAENTRY";
    formData: Dtos.TrialInstitutionItemCustomView;

}

export interface ITrialInstitutionItemCustomViewSaveDataEntryActionCreator {
    (
        formData: Dtos.TrialInstitutionItemCustomView
    ): ITrialInstitutionItemCustomViewSaveDataEntryAction;
}

export interface ITrialInstitutionItemCustomViewSaveSuccessAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_SUCCESS";
    formData: Dtos.TrialInstitutionItemCustomView;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemCustomViewSaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionItemCustomView,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionItemCustomViewSaveSuccessAction;
}

export interface ITrialInstitutionItemCustomViewSaveFailureAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionItemCustomViewSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemCustomViewSaveFailureAction;
}

export interface ITrialInstitutionItemCustomViewCreateAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE",
    trialId: number,
    institutionId: number,
    formTemplateId: number
}

export interface ITrialInstitutionItemCustomViewCreateActionCreator {
    (trialId: number, institutionId: number, formTemplateId: number): ITrialInstitutionItemCustomViewCreateAction
}

export interface ITrialInstitutionItemCustomViewCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_SUCCESS";
    formData: Dtos.TrialInstitutionItemCustomView;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialInstitutionItemCustomViewCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionItemCustomView,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionItemCustomViewCreateSuccessAction;
}

export interface ITrialInstitutionItemCustomViewCreateFailureAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionItemCustomViewCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemCustomViewCreateFailureAction;
}


export interface ITrialInstitutionItemCustomViewClearAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionItemCustomViewClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionItemCustomViewClearAction;
}

export interface ITrialInstitutionItemCustomViewFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionItemCustomViewFilterAction;
}

export interface ITrialInstitutionItemCustomViewFilterAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_FILTER";
    formFilter: IFormFilter;
}


export type TrialInstitutionItemCustomViewAction =
    ITrialInstitutionItemCustomViewLoadAction |
    ITrialInstitutionItemCustomViewLoadByIdAction |
    ITrialInstitutionItemCustomViewLoadDataEntryByIdAction |
    ITrialInstitutionItemCustomViewLoadFailureAction |
    ITrialInstitutionItemCustomViewLoadSuccessAction |
    ITrialInstitutionItemCustomViewSaveAction |
    ITrialInstitutionItemCustomViewSaveDataEntryAction |
    ITrialInstitutionItemCustomViewSaveSuccessAction |
    ITrialInstitutionItemCustomViewSaveFailureAction |
    ITrialInstitutionItemCustomViewCreateAction |
    ITrialInstitutionItemCustomViewCreateSuccessAction |
    ITrialInstitutionItemCustomViewCreateFailureAction |
    ITrialInstitutionItemCustomViewClearAction |
    ITrialInstitutionItemCustomViewFilterAction;
